// RegisterPage.tsx
import React from 'react';
import DynamicLayout from '../components/DynamicLayout';
import Register from '../components/Register';
import NoIndexHelmet from '../components/NoIndexHelmet';

const RegisterPage = () => {
    return (
        <DynamicLayout isAuthScreen>
            <NoIndexHelmet title="Register | Saturnalia" />
            <div
                className="full-screen-image-container hundredminnavdesktop margin-top-0"
                style={{
                    backgroundImage: `url('/img/saturnwallpaper.jpg')`,
                }}
            >
                <Register />
            </div>
        </DynamicLayout>
    );
};

export default RegisterPage;
